import { Button, Card, Col, Row, Space, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { selectCMSForUpdate, selectIsUpdateCMS } from "../../../../redux";
import { DataCMS } from "../../../../redux/@types/cms";
import {
  AdminMenuLayout,
  InputHTML,
  InputSelect,
  InputText,
} from "../../../../shared/components";
import { BRAND } from "../../../../shared/theme/brand";
import { useCMS } from "../../hook";

const { Title, Text } = Typography;

export const CMSById = () => {
  const navigate = useNavigate();
  const isUpdateCMS = useSelector(selectIsUpdateCMS);
  const updateCMS = useSelector(selectCMSForUpdate);
  const { isLoading, onSubmitCreateOrUpdate } = useCMS();

  const { control, handleSubmit: onSubmit } = useFormContext<DataCMS>();

  return (
    <AdminMenuLayout
      pageDescription={isUpdateCMS ? "Editar CMS" : "Nuevo CMS"}
      title={isUpdateCMS ? "Editar contenido" : "Nuevo contenido"}
    >
      <Card
        bodyStyle={{ padding: "24px", display: "block" }}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            marginBottom: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 16,
            gap: 12,
          }}
        >
          <Space align="center" size={12}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/cms")}
            />
            <div>
              <h2
                style={{
                  fontSize: 20,
                  fontWeight: 600,
                  margin: 0,
                  color: "#262626",
                }}
              >
                {isUpdateCMS
                  ? `Editar: ${updateCMS?.title || `CMS #${updateCMS?.id}`}`
                  : "Crear contenido CMS"}
              </h2>
              <Text type="secondary" style={{ fontSize: 13 }}>
                Páginas legales y de soporte visibles en la app
              </Text>
            </div>
          </Space>
        </div>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Title style={{ marginBottom: 8 }} level={5}>
              Título
            </Title>
            <InputText placeHolder="Ej. Política de Privacidad" name="title" control={control} />
          </Col>
          <Col xs={24} md={12}>
            <Title style={{ marginBottom: 8 }} level={5}>
              Estado
            </Title>
            <InputSelect
              name="status"
              control={control}
              dataOptions={[
                { title: "Activo", value: "active" },
                { title: "Inactivo", value: "inactive" },
              ]}
              label=""
            />
          </Col>
          <Col span={24}>
            <Title style={{ marginBottom: 8 }} level={5}>
              Contenido
            </Title>
            {isUpdateCMS ? (
              <InputHTML
                placeHolder="Lea atentamente antes de aceptar...."
                name="body"
                control={control}
                isUpdating
              />
            ) : (
              <InputHTML
                placeHolder="Lea atentamente antes de aceptar...."
                name="body"
                control={control}
              />
            )}
          </Col>
          <Col span={24}>
            <Button
              type="primary"
              size="large"
              block
              loading={isLoading}
              onClick={onSubmit(onSubmitCreateOrUpdate)}
              style={{
                marginTop: 8,
                borderRadius: 30,
                height: 44,
                fontWeight: 600,
                boxShadow: BRAND.primaryShadow,
              }}
            >
              {isUpdateCMS ? "Actualizar información" : "Crear contenido"}
            </Button>
          </Col>
        </Row>
      </Card>
    </AdminMenuLayout>
  );
};
